import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class TipoIrregularidadeEmpresaDTO extends BaseEntity {
  public codigo: string;
  public nome: string;
}

export class IrregularidadeEmpresaDTO extends BaseEntity {
  public tipo: TipoIrregularidadeEmpresaDTO;
  public cnpj: string;
	public dataInicio: Date;
	public dataFim: Date;
}

export class FiltroIrregularidadeEmpresaDto {

}
